import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import store from './vuex/'
import router from './router/'
import './components/index'
import './plugins/index'
import $ from 'jquery'
Vue.config.productionTip = false
window.$ = $
new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')
